/**
 * DASHBOARD EDIT ATTRIBUTE MODAL
 * Edit the attribute
 */

import Modal from "@/components/modal"
import { WithTranslation, withTranslation } from "react-i18next"
import { Attribute } from "@/redux/attribute.types"
import TextInput from "@/components/text-input"
import { useState } from "react"
import { store } from ".."
import LoadingModal from "./loading.modal"
import { attributeUpdate } from "@/redux/attribute.actions"

interface OwnProps {
  currentAttribute: Attribute
  onClose: Function
}

type Props = OwnProps & WithTranslation

function DashboardEditAttributeModal(props: Props) {
  const { t } = props

  const [name, setName] = useState(props.currentAttribute.name)
  const [filterName, setFilterName] = useState(props.currentAttribute.filterName)
  const [isSaving, setIsSaving] = useState(false)

  async function close() {
    props.onClose()
  }

  async function next() {
    setIsSaving(true)
    const response: any = await store.dispatch(attributeUpdate(props.currentAttribute.aid, name, filterName))
    setIsSaving(false)

    if (!response.error) {
      close()
    }
  }

  return (
    <Modal isCloseButtonVisible title={t("filter_edit")} onClose={close} onNext={next}>
      {isSaving && <LoadingModal />}
      <TextInput title={t("population")} value={name} onChange={(e) => setName(e.value)} />
      <TextInput title={t("filter")} value={filterName} onChange={(e) => setFilterName(e.value)} />
      <div className="height-40" />
    </Modal>
  )
}

export default withTranslation()(DashboardEditAttributeModal)
